import { getStatusColors } from "@/components/table-utils/get-status-color";
import TableRowActionGroup from "@/components/table-utils/table-row-action-group";
import routes from "@/routers/routes";
import DateCell from "@/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import { ActionIcon, Badge, Checkbox, Tooltip } from "rizzui";
import { Order } from "@/types";
import EyeIcon from "@/components/icons/eye";

const columnHelper = createColumnHelper<Order>();

export const paymentOrderListColumns = [
    columnHelper.accessor("orderId", {
        id: "orderId",
        size: 150,
        header: "Order ID",
        cell: ({ row }) => (
            <Link
                to={routes.orders.orderDetails(row.original.id)}
                className="duration-200 hover:text-gray-900 hover:underline"
            >
                {row.original.orderId}
            </Link>
        ),
    }),
    columnHelper.accessor("createdDate", {
        id: "createdDate",
        size: 150,
        header: "Date",
        cell: ({ row }) => (
            <DateCell date={new Date(row.original.createdDate)} />
        ),
    }),
    columnHelper.accessor("client.fullname", {
        id: "client",
        size: 250,
        header: "Client",
        enableSorting: false,
        cell: ({ row }) => (
            <div>
                <span>{row.original.client?.fullname ?? ""}</span> <br />
                <span>{row.original.client?.email}</span>
            </div>
        ),
        // <AvatarCard
        //     avatarProps={{
        //         name: row.original.client?.email ?? "",
        //         size: "md",
        //         rounded: "md",
        //     }}
        //     src={""}
        //     name={row.original.client?.email ?? ""}
        // />
    }),
    columnHelper.accessor("product.name", {
        id: "product",
        size: 250,
        header: "Product",
        enableSorting: false,
        cell: ({ row }) => row.original.product?.name ?? "",
        // <AvatarCard
        //     avatarProps={{
        //         name: row.original.product?.name ?? "",
        //         size: "md",
        //         rounded: "md",
        //     }}
        //     src={""}
        //     name={row.original.product?.name ?? ""}
        // />
    }),
    columnHelper.accessor("quantity", {
        id: "quantity",
        size: 120,
        header: "Quantity",
        cell: ({ row }) => row.original.quantity,
    }),
    columnHelper.accessor("paymentMethod", {
        id: "category",
        size: 220,
        header: "Category",
        cell: ({ row }) => row.original.product.category?.name,
    }),
    columnHelper.accessor("status", {
        id: "status",
        size: 180,
        header: "Status",
        cell: ({ row }) => (
            <div className="flex items-center gap-1.5">
                <Badge
                    variant="outline"
                    color={getStatusColors(row.original.status)}
                >
                    {row.original.status}
                </Badge>
            </div>
        ),
    }),
    columnHelper.display({
        id: "actions",
        size: 120,
        cell: ({
            row,
            table: {
                options: { meta },
            },
        }) => (
            <Tooltip
                size="sm"
                content="View Item"
                placement="top"
                color="invert"
            >
                <Link to={routes.orders.billingDetails(row.original.id)}>
                    <ActionIcon
                        as="span"
                        size="sm"
                        variant="outline"
                        aria-label="View item"
                    >
                        <EyeIcon className="size-4" />
                    </ActionIcon>
                </Link>
            </Tooltip>
        ),
    }),
];
